// source: pbtypes/gen/scan_planner/polygon_prism.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_structure_scan_polygon_pb = require('../../../pbtypes/gen/structure_scan/polygon_pb.js');
goog.object.extend(proto, pbtypes_gen_structure_scan_polygon_pb);
goog.exportSymbol('proto.scan_planner.PolygonPrism', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.PolygonPrism = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.PolygonPrism, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.PolygonPrism.displayName = 'proto.scan_planner.PolygonPrism';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.PolygonPrism.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.PolygonPrism.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.PolygonPrism} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.PolygonPrism.toObject = function(includeInstance, msg) {
  var f, obj = {
polygon: (f = msg.getPolygon()) && pbtypes_gen_structure_scan_polygon_pb.Polygon.toObject(includeInstance, f),
maxHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
minHeight: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.PolygonPrism}
 */
proto.scan_planner.PolygonPrism.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.PolygonPrism;
  return proto.scan_planner.PolygonPrism.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.PolygonPrism} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.PolygonPrism}
 */
proto.scan_planner.PolygonPrism.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_structure_scan_polygon_pb.Polygon;
      reader.readMessage(value,pbtypes_gen_structure_scan_polygon_pb.Polygon.deserializeBinaryFromReader);
      msg.setPolygon(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMaxHeight(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMinHeight(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.PolygonPrism.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.PolygonPrism.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.PolygonPrism} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.PolygonPrism.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPolygon();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_structure_scan_polygon_pb.Polygon.serializeBinaryToWriter
    );
  }
  f = message.getMaxHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getMinHeight();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional structure_scan.Polygon polygon = 1;
 * @return {?proto.structure_scan.Polygon}
 */
proto.scan_planner.PolygonPrism.prototype.getPolygon = function() {
  return /** @type{?proto.structure_scan.Polygon} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_structure_scan_polygon_pb.Polygon, 1));
};


/**
 * @param {?proto.structure_scan.Polygon|undefined} value
 * @return {!proto.scan_planner.PolygonPrism} returns this
*/
proto.scan_planner.PolygonPrism.prototype.setPolygon = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.PolygonPrism} returns this
 */
proto.scan_planner.PolygonPrism.prototype.clearPolygon = function() {
  return this.setPolygon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.PolygonPrism.prototype.hasPolygon = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float max_height = 2;
 * @return {number}
 */
proto.scan_planner.PolygonPrism.prototype.getMaxHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.PolygonPrism} returns this
 */
proto.scan_planner.PolygonPrism.prototype.setMaxHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float min_height = 3;
 * @return {number}
 */
proto.scan_planner.PolygonPrism.prototype.getMinHeight = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.PolygonPrism} returns this
 */
proto.scan_planner.PolygonPrism.prototype.setMinHeight = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


goog.object.extend(exports, proto.scan_planner);
